import { connect } from 'react-redux';
//
import CostsModal from 'components/formula-entry/modals/costs/costs';
import { IStoreState } from 'store';
import { cancelFormulaEdit } from 'store/formula-entry/actions';
import { updateProductField } from 'store/deal-edit/actions';
import { setLoading } from 'store/loading/actions';
import { ELoadingType } from 'store/loading/types';
import { getDealEvaluation } from 'store/deal-evaluation/actions';
import { ICostFormulaGroup, ECostFormulaType } from 'store/cost-formulas/types';
import { IPrice, IFieldOption } from 'store/field-options/types';
import { getMfgCostFormulaByName } from 'components/formula-entry/modals/costs/selectors';

export interface ICostsModalStateProps {
  defaultTransportModes: IFieldOption[] | undefined;
  defaultIncoTerms: IFieldOption[] | undefined;
  availableCostFormulaGroups: ICostFormulaGroup[];
  mfgCostName: string;
  mfgCostFormulaTrue: string;
  mfgCostFormulaItp: string;
  priceDescription: string;
  priceCostFreight: string;
  priceCostReimbursed: string;
  priceCostFixed: string;
  priceCostIncInventory: string;
  priceCostTransitDays: string;
  batnaDescription: string;
  batnaCostFreight: string;
  batnaCostReimbursed: string;
  batnaCostFixed: string;
  batnaCostIncInventory: string;
  batnaCostTransitDays: string;
  productIndex: number | null;
  volumeUnit: string;
  otherBatnas: IPrice[];
  transportMode: string;
  incoTerm: string;
  otherSupply: string;
}

export interface ICostsModalDispatchProps {
  cancelFormulaEdit: () => void;
  getDealEvaluation: () => void;
  setLoading: (loading: ELoadingType) => void;
  updateProductField: Function;
}

export type TCostsModalProps = ICostsModalStateProps & ICostsModalDispatchProps;

const mapStateToProps = ({ formulaEntry, dealEdit, costFormulas, fieldOptions }: IStoreState) => {
  const props: ICostsModalStateProps = {
    availableCostFormulaGroups: costFormulas.data,
    mfgCostName: '',
    mfgCostFormulaTrue: '',
    mfgCostFormulaItp: '',
    priceDescription: '',
    priceCostFreight: '',
    priceCostReimbursed: '',
    priceCostFixed: '',
    priceCostIncInventory: '',
    priceCostTransitDays: '',
    batnaDescription: '',
    batnaCostFreight: '',
    batnaCostReimbursed: '',
    batnaCostFixed: '',
    batnaCostIncInventory: '',
    batnaCostTransitDays: '',
    productIndex: null,
    volumeUnit: '',
    otherBatnas: [],
    defaultIncoTerms: [],
    defaultTransportModes: [],
    incoTerm: '',
    transportMode: '',
    otherSupply: '',
  };
  const { productIndex } = formulaEntry;
  const { products } = dealEdit;
  const { defaultIncoTerms, defaultTransportModes } = fieldOptions;
  props.defaultIncoTerms = defaultIncoTerms;
  props.defaultTransportModes = defaultTransportModes;
  if (!products || productIndex === null) {
    return props;
  }
  props.productIndex = productIndex;

  const product = products[productIndex];
  const { basePrice, mainBatna, volumeUnit, mfgCost, otherBatnas, transportMode, incoTerm, otherSupply } = product;

  if (!basePrice || !mainBatna || !volumeUnit) {
    return props;
  }
  props.volumeUnit = volumeUnit;

  const {
    description: priceDescription,
    costFreight: priceCostFreight,
    costReimbursed: priceCostReimbursed,
    costFixed: priceCostFixed = '',
    costIncInventory: priceCostIncInventory = '',
    costTransitDays: priceCostTransitDays = '',
  } = basePrice;

  const {
    description: batnaDescription,
    costFreight: batnaCostFreight,
    costReimbursed: batnaCostReimbursed,
    costFixed: batnaCostFixed = '',
    costIncInventory: batnaCostIncInventory = '',
    costTransitDays: batnaCostTransitDays = '',
  } = mainBatna;

  props.priceDescription = priceDescription;
  props.priceCostFreight = priceCostFreight.toString();
  props.priceCostReimbursed = priceCostReimbursed.toString();
  props.priceCostFixed = priceCostFixed.toString();
  props.priceCostIncInventory = priceCostIncInventory.toString();
  props.priceCostTransitDays = priceCostTransitDays.toString();
  props.batnaDescription = batnaDescription;
  props.batnaCostFreight = batnaCostFreight.toString();
  props.batnaCostReimbursed = batnaCostReimbursed.toString();
  props.batnaCostFixed = batnaCostFixed.toString();
  props.batnaCostIncInventory = batnaCostIncInventory.toString();
  props.batnaCostTransitDays = batnaCostTransitDays.toString();
  props.mfgCostName = mfgCost ?? '';
  props.mfgCostFormulaTrue = getMfgCostFormulaByName(ECostFormulaType.TRUE_COST, costFormulas.data, mfgCost);
  props.mfgCostFormulaItp = getMfgCostFormulaByName(ECostFormulaType.ITP, costFormulas.data, mfgCost);
  props.otherBatnas = otherBatnas ?? [];
  props.incoTerm = incoTerm || '';
  props.transportMode = transportMode || '';
  props.otherSupply = otherSupply || '';

  return props;
};

const mapDispatchToProps = {
  cancelFormulaEdit,
  getDealEvaluation,
  setLoading,
  updateProductField,
};

export default connect(mapStateToProps, mapDispatchToProps)(CostsModal);
